<div mat-dialog-content>

  <div class="col-md-12">
    <div class="modal-header">
      <h2 class="col text-center">
        <b>{{'WORKGROUPS.WORKGROUPS' | translate}}</b>
      </h2>
      <button type="button" data-dismiss="modal" aria-label="Close" (click)="onNoClick()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="row px-5">
      <mat-form-field appearance="outline">
        <input matInput [(ngModel)]="searchTerm" [placeholder]="'Buscar grupo...'" />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
    </div>

    <div class="px-5">

      <div class="center">
        <i class="fas fa-circle green-icon"></i>&nbsp;
        {{'WORKGROUPS.TRAFFIC' | translate}}
      </div>
      <br>
      <div class="center">
        <i class="fas fa-circle red-icon"></i>&nbsp;
        {{'WORKGROUPS.COMERCIAL' | translate}}
      </div>
      <br>

      <div class="center">
        <i class="fas fa-circle yellow-icon"></i>&nbsp;
        {{'WORKGROUPS.UNCLASSIFIED' | translate}}
      </div>
      <br>

      <div class="center">
        <i class="fas fa-circle purple-icon"></i>&nbsp;
        {{'WORKGROUPS.SALES' | translate}}
      </div>
      <br>

      <div class="center">
        <i class="fas fa-circle orange-icon"></i>&nbsp;
        {{'WORKGROUPS.TESTS' | translate}}
      </div>
      <br>

      <div class="center">
        <i class="fas fa-circle blue-icon"></i>&nbsp;
        {{'WORKGROUPS.REPORTS' | translate}}
      </div>
    </div>

  </div>
</div>

